export const FLUSH_PROGRAM_PREVIEW: 'PROGRAM_PREVIEW/FLUSH' = 'PROGRAM_PREVIEW/FLUSH';
export const LOAD: 'PROGRAM_PREVIEW/LOAD' = 'PROGRAM_PREVIEW/LOAD';
export const LOAD_SUCCESS: 'PROGRAM_PREVIEW/LOAD/SUCCESS' = 'PROGRAM_PREVIEW/LOAD/SUCCESS';
export const LOAD_FAILURE: 'PROGRAM_PREVIEW/LOAD/FAILURE' = 'PROGRAM_PREVIEW/LOAD/FAILURE';
export const START: 'PROGRAM_PREVIEW/START' = 'PROGRAM_PREVIEW/START';
export const START_SUCCESS: 'PROGRAM_PREVIEW/START/SUCCESS' = 'PROGRAM_PREVIEW/START/SUCCESS';
export const START_FAILURE: 'PROGRAM_PREVIEW/START/FAILURE' = 'PROGRAM_PREVIEW/START/FAILURE';
export const RESET_HAS_PROGRAM_CHANGED: 'PROGRAM_PREVIEW/RESET_HAS_PROGRAM_CHANGED' =
	'PROGRAM_PREVIEW/RESET_HAS_PROGRAM_CHANGED';
export const OVERWRITE: 'PROGRAM_PREVIEW/START/OVERWRITE' = 'PROGRAM_PREVIEW/START/OVERWRITE';
export const OVERWRITE_SUCCESS: 'PROGRAM_PREVIEW/OVERWRITE/SUCCESS' = 'PROGRAM_PREVIEW/OVERWRITE/SUCCESS';
export const OVERWRITE_FAILURE: 'PROGRAM_PREVIEW/OVERWRITE/FAILURE' = 'PROGRAM_PREVIEW/OVERWRITE/FAILURE';
export const REPLACE: 'PROGRAM_PREVIEW/START/REPLACE' = 'PROGRAM_PREVIEW/START/REPLACE';
export const REPLACE_SUCCESS: 'PROGRAM_PREVIEW/REPLACE/SUCCESS' = 'PROGRAM_PREVIEW/REPLACE/SUCCESS';
export const REPLACE_FAILURE: 'PROGRAM_PREVIEW/REPLACE/FAILURE' = 'PROGRAM_PREVIEW/REPLACE/FAILURE';
